import React, {useEffect, useMemo, useRef, useState} from 'react'
import {Tabs, Tab} from 'react-bootstrap'
import ToggleSwitch from 'react-bootstrap/Form'
import DatePicker from 'react-datepicker'
import YouTube, {YouTubeProps} from 'react-youtube'
import moment from 'moment'
import {useDispatch, useSelector} from 'react-redux'
import {CreateData, GetAllData, UpdateData} from './LandingPageSlice/LandingPageSlice'
import {useLocation, useNavigate} from 'react-router-dom'
import {Editor} from './QuillCustom/CustomEditer'
import './QuillCustom/Quill.css'
import {saveAs} from 'file-saver'
import './MobileView.scss'
import './LandingPage.css'

import {createEvent} from 'ics'
import {GetData} from '../Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import WSButton from '../../../../_metronic/helpers/components/WSButton/WSButton'
import {openPopup} from '../../../Components/PopupSlice/popupSlice'
import {Formik, Form, FieldArray, Field, ErrorMessage, useFormikContext} from 'formik'
import {LandingPageValidation} from '../../../Utils/_helpers/ValidationSchema'

const CreateLandingPage = ({show, handleClose}: any) => {
  const formik: any = useFormikContext()
  const dispatch = useDispatch()
  const aRef: any = useRef(null)
  const imgRef: any = useRef(null)
  const navigate = useNavigate()
  let listData = useSelector((state: any) => state?.subscriberData?.FieldName?.data?.fields)
  const [landingPageName, setLandingPageName] = useState('')

  useEffect(() => {
    dispatch(GetData())
  }, [])

  const inputRef: any = useRef()
  const param: any = useLocation()

  const opts: YouTubeProps['opts'] = {
    height: '390',
    width: '640',
    playerVars: {
      autoplay: 1,
    },
  }
  const onPlayerReady: YouTubeProps['onReady'] = (event: any) => {
    event.target.pauseVideo()
  }
  const [landingPageData, setLandingPageData] = useState({
    campaignName: '',
    header: {
      name: 'header',
      logo: '',
      logoName: '',
      campaignMessage: '',
      media: '',
      mediaName: '',
      youtubeLink: '',
      toggleHeader: true,
      imageToggle: true,
      toggleHeroMedia: true,
    },
    quote: [
      {
        content: '',
        backgroundImage: '',
        backgroundImageName: '',
        toggleQuote: false,
      },
    ],
    bulletPoints: [
      {
        content: '',
        toggleBulletPoint: false,
      },
    ],

    whereWhen: {
      name: 'whereWhen',
      eventTitle: '',
      eventDescription: '',
      address: '',
      start: null,
      end: null,
      rsvpButtons: true,
      toggleWhereWhen: false,
    },
    rsvp: {
      name: 'rsvp',
      email: '',
      title: '',
      option: [''],
      toggleRsvp: false,
    },
  })
  const [rsvpButton, setRsvpButton] = useState(false)
  const [toggleHeader, setToggleHeader] = useState(true)

  useEffect(() => {
    if (param?.state?._id !== undefined) {
      const {campaignName, state} = param
      const arr: any = Object.values(state)
      // Assuming the API response object is stored in the variable 'apiResponse'

      const transformedData = {
        campaignName: state.campaignName,
        header: {
          name: 'header',
          logo: state?.header.logo,
          logoName: state?.header.logoName,
          campaignMessage: state?.header.campaignMessage,
          media: state?.header.media,
          mediaName: state?.header.mediaName,
          youtubeLink: state?.header.youtubeLink,
          toggleHeader: true, // or any other default value you want
          imageToggle: state?.header.media ? true : false, // or any other default value you want
          toggleHeroMedia: state?.header.media || state?.header.youtubeLink ? true : false,
        },
        quote:
          state?.quote?.data?.length > 0
            ? state?.quote?.data.map((item: any) => ({
                content: item?.content || '',
                backgroundImage: item?.backgroundImage || '',
                backgroundImageName: item?.backgroundImageName || '',
                toggleQuote: item?.content !== '' ? true : false, // or any other default value you want
              }))
            : landingPageData.quote,
        bulletPoints:
          state?.bulletPoints?.data?.length > 0
            ? state?.bulletPoints?.data.map((item: any) => ({
                content: item.content,
                toggleBulletPoint: item.content !== '' ? true : false, // or any other default value you want
              }))
            : landingPageData.bulletPoints,
        whereWhen: {
          name: 'whereWhen',
          eventTitle: state?.whereWhen?.eventTitle || '',
          eventDescription: state?.whereWhen?.eventDescription || '',
          address: state?.whereWhen?.address || '',
          start: state?.whereWhen?.start || null,
          end: state?.whereWhen?.end || null,
          rsvpButtons: state?.rsvpButtons || true,
          toggleWhereWhen: state?.whereWhen?.eventTitle ? true : false, // or any other default value you want
        },
        rsvp: {
          name: 'rsvp',
          email: state?.rsvp?.email || '',
          title: state?.rsvp?.title || '',
          option:
            state?.rsvp?.option?.length > 0
              ? state?.rsvp?.option?.map((key: any) => Object.values(key)?.at(0))
              : [''],
          toggleRsvp: state?.rsvp?.email !== '' && state?.rsvp?.email !== undefined ? true : false, // or any other default value you want
        },
      }

      setLandingPageData(transformedData)
    }
  }, [param?.state?._id])

  const handleSubmit = (value: any) => {
    // LandingPageValidation()

    const finalData = new FormData()
    const fff: any = {}

    if (toggleHeader) {
      fff.header = value.header
    }
    if (value?.quote?.filter((data: any) => data?.toggleQuote)?.length > 0) {
      fff.quote = {name: 'quote', data: value?.quote?.filter((data: any) => data?.toggleQuote)}
    }
    if (value?.bulletPoints?.filter((data: any) => data?.toggleBulletPoint)?.length > 0) {
      fff.bulletPoints = {
        name: 'bulletPoints',
        data: value?.bulletPoints?.filter((data: any) => data?.toggleBulletPoint),
      }
    }

    if (value.whereWhen.toggleWhereWhen) {
      fff.whereWhen = value.whereWhen
    }
    if (value.rsvp.toggleRsvp) {
      let finalOption: any = value.rsvp?.option?.map((key: any, index: number) => {
        let keyLabel = `option${index + 1}`
        return {[`${keyLabel}`]: key}
      })

      fff.rsvp = {...value.rsvp, option: finalOption}
    }
    for (var key in fff) {
      finalData.append(key, JSON.stringify(fff[key]))
    }
    finalData.append('files', value.header.logo)
    finalData.append('files', value.header.media)
    value.quote?.map((key: any) => finalData?.append('files', key?.backgroundImage))
    finalData.append('rsvpButtons', rsvpButton?.toString())
    finalData.append('campaignName', value.campaignName)

    if (param?.state?._id === undefined) {
      dispatch(CreateData(finalData))
      navigate('/landing-page')
    } else {
      dispatch(
        UpdateData({
          id: param?.state?._id,
          data: finalData,
        })
      )
      navigate('/landing-page')
    }

    // bullet_Points?.map((key:any)=>(
    //   finalData?.append('files',key?.backgroundImage)
    // ))
  }

  // const handleChange = (i: any, e: any) => {
  //   let newFormValues: any = [...rsvp.option]
  //   newFormValues?.splice(i, 1, e.target.value)
  //   setRsvp({...rsvp, option: newFormValues})
  // }

  // const googleCalander = () => {
  //   let estart = whereWhen?.start !== null ? whereWhen.start?.toISOString() : whereWhen?.start
  //   let eEnd = whereWhen.end !== null ? whereWhen.end?.toISOString() : whereWhen.end
  //   const data = {
  //     start: estart,
  //     end: eEnd,
  //     title: header.campaignMessage,
  //     location: whereWhen.address,
  //     description: whereWhen.eventDescription,
  //   }
  //   window.open(
  //     `https://calendar.google.com/calendar/u/0/r/eventedit?text=${
  //       data.title
  //     }&dates=${data.start.replaceAll('-', '')}/${data.end.replaceAll('-', '')}&details=${
  //       data.description
  //     }&location=${data.location}`
  //   )
  // }

  // const downloadIcal = () => {
  //   const data = {
  //     start: whereWhen.start.toISOString(),
  //     end: whereWhen.end.toISOString(),
  //     title: header.campaignMessage,
  //     location: whereWhen.address,
  //     description: whereWhen.eventDescription,
  //   }

  //   createEvent(data, (error, value) => {
  //     const blob = new Blob([value], {type: 'text/plain;charset=utf-8'})
  //     saveAs(blob, 'event-schedule.ics')
  //   })
  // }

  return (
    <>
      <div className='card '>
        <div className='card-header border-0 pt-12 ps-xl-14'>
          <h3 className='card-title align-items-start flex-column me-5'>
            <span className='card-label fw-bolder fs-2 mb-1'>Create new landing page</span>
            <span className='text-muted mt-1 fw-light fs-7'>
              If you still need more info, visit{' '}
              <a onClick={() => dispatch(openPopup('Dummy text'))} className='fw-light'>
                Help Page
              </a>
            </span>
          </h3>
        </div>

        <Formik
          enableReinitialize
          initialValues={landingPageData}
          validationSchema={LandingPageValidation}
          onSubmit={(values) => {
            handleSubmit(values)
          }}
        >
          {({values, setFieldValue, errors}: any) => (
            <Form>
              <div className='row p-5 p-md-10'>
                <div className='col-xl-8 landing_left'>
                  <div className=' border rounded border-2  p-7 ps-9 my-5'>
                    <div className='d-flex align-items-center justify-content-between position-relative'>
                      <h2 className=' text-bold m-0'>
                        <span className='six-dot'>
                          <img
                            src={toAbsoluteUrl('/media/icons/duotune/art/six-dot.svg')}
                            className='me-5'
                          />
                        </span>
                        Header
                      </h2>
                      <ToggleSwitch.Check
                        onChange={() =>
                          setFieldValue('header.toggleHeader', !values.header.toggleHeader)
                        }
                        checked={values.header.toggleHeader}
                        type='switch'
                        id='custom-switch'
                      />
                    </div>

                    {values.header.toggleHeader && (
                      <>
                        <div className='row mt-7'>
                          <h4>Logo</h4>
                          <input
                            type={'file'}
                            ref={aRef}
                            onChange={(e: any) => {
                              setFieldValue('header.logo', e.target.files[0])
                              setFieldValue('header.logoName', e.target.files[0]?.name)
                            }}
                            accept={'.jpeg,.png'}
                            style={{display: 'none'}}
                            id='upload_logo'
                          />
                          <label
                            htmlFor='upload_logo'
                            className='ms-3 mb-5 col-8 col-sm-6 col-md-3 btn btn-light-primary text-nowrap'
                          >
                            Upload logo
                          </label>
                          <ErrorMessage
                            name='header.logo'
                            component='div'
                            className='text-danger'
                          />
                        </div>
                        <div className='d-flex'>
                          {values.header.logoName !== '' && (
                            <span className='text-bold'>File Name:-{values.header.logoName}</span>
                          )}
                          {values.header.logoName !== '' && (
                            <span className='ms-2'>
                              <button
                                type='button'
                                className='btn btn-sm btn-icon btn-light btn-light-danger fw-500 fs-7 h-100 mh-20px w-20px d-flex justify-content-center align-items-center'
                                onClick={() => {
                                  aRef.current.value = null
                                  setFieldValue('header.logo', '')
                                  setFieldValue('header.logoName', '')
                                }}
                              >
                                X
                              </button>
                            </span>
                          )}
                        </div>
                        <div className='row mt-6'>
                          <h4>Campaign key message</h4>
                          <div className='col-md-6 mb-4 col-lg-10 d-flex align-items-center '>
                            <Field
                              value={values?.header?.campaignMessage}
                              name='header.campaignMessage'
                              type='text'
                              className='form-control form-control-lg form-control-solid'
                            />
                            <ErrorMessage
                              name='header.campaignMessage'
                              component='div'
                              className='text-danger'
                            />
                          </div>
                        </div>

                        <div className='row mt-6'>
                          <div className=''>
                            <h4>Hero media</h4>

                            <ToggleSwitch.Check
                              onChange={() => {
                                setFieldValue(
                                  'header.toggleHeroMedia',
                                  !values.header.toggleHeroMedia
                                )

                                setFieldValue('header.media', '')
                                setFieldValue('header.mediaName', '')
                                setFieldValue('header.youtubeLink', '')
                              }}
                              className='pull-right'
                              checked={values.header.toggleHeroMedia}
                              type='switch'
                              id='custom-switch'
                            />
                          </div>
                          {values.header.toggleHeroMedia ? (
                            <>
                              <div className='col-md-6 mb-6 col-lg-10 d-flex align-items-center '>
                                <div
                                  onClick={() => setFieldValue('header.imageToggle', true)}
                                  className={`btn ${
                                    values.header.imageToggle && 'btn-light-primary'
                                  }  btn btn-outline btn-outline-dashed btn-outline-default py-4 m-2 ms-0`}
                                >
                                  Image
                                </div>
                                <div
                                  onClick={() => setFieldValue('header.imageToggle', false)}
                                  className={`btn ${
                                    !values.header.imageToggle && 'btn-light-primary'
                                  }  btn btn-outline btn-outline-dashed btn-outline-default py-4 m-2`}
                                >
                                  Youtube Link
                                </div>
                              </div>
                              <div>
                                {values.header.imageToggle ? (
                                  <>
                                    <h4>Add image</h4>
                                    <input
                                      ref={imgRef}
                                      type={'file'}
                                      onChange={(e: any) => {
                                        setFieldValue('header.media', e.target.files[0])
                                        setFieldValue('header.mediaName', e.target.files[0]?.name)
                                        setFieldValue('header.youtubeLink', '')
                                      }}
                                      accept={'.jpeg,.png'}
                                      style={{display: 'none'}}
                                      id='upload_image'
                                    />
                                    <label htmlFor='upload_image' className='btn btn-primary'>
                                      Upload image
                                    </label>
                                    <ErrorMessage
                                      name='header.media'
                                      component='div'
                                      className='text-danger'
                                    />
                                  </>
                                ) : (
                                  <div className='col-md-5 col-lg-10'>
                                    <h4 className='mb-2'>Paste link</h4>
                                    <input
                                      value={values?.header?.youtubeLink}
                                      onChange={(e: any) => {
                                        setFieldValue('header.media', '')
                                        setFieldValue('header.mediaName', '')
                                        setFieldValue('header.youtubeLink', e.target.value)
                                      }}
                                      className='form-control form-control-lg form-control-solid'
                                      placeholder='Paste youtube link here...'
                                    />
                                    <ErrorMessage
                                      name='header.youtubeLink'
                                      component='div'
                                      className='text-danger'
                                    />
                                  </div>
                                )}
                                {values.header.imageToggle && values?.header?.media !== '' && (
                                  <div className='d-flex mt-3'>
                                    <span>{values?.header?.mediaName}</span>
                                    <span className='ms-2'>
                                      <WSButton
                                        type='button'
                                        className={
                                          'btn btn-sm btn-icon btn-light btn-light-danger fw-500 fs-7 h-100 mh-20px w-20px d-flex justify-content-center align-items-center'
                                        }
                                        onClick={() => {
                                          imgRef.current.value = null
                                          setFieldValue('header.media', '')
                                          setFieldValue('header.mediaName', '')
                                          setFieldValue('header.youtubeLink', '')
                                        }}
                                        iconPath='/media/icons/duotune/arrows/arr061.svg'
                                        iconClass='svg-icon-8 mb-1'
                                      />
                                    </span>
                                  </div>
                                )}
                              </div>
                            </>
                          ) : null}
                        </div>
                      </>
                    )}
                  </div>
                  <FieldArray name='quote'>
                    {({push, remove}) => (
                      <div>
                        {values.quote.map((quote: any, index: any) => (
                          <div className='border rounded border-2  p-7 ps-9 my-5' key={index}>
                            <div className='d-flex align-items-center justify-content-between position-relative'>
                              <h2 className=' text-bold col-4 m-0'>
                                <span className='six-dot'>
                                  <img
                                    src={toAbsoluteUrl('/media/icons/duotune/art/six-dot.svg')}
                                    className='me-5'
                                  />
                                </span>
                                Quote
                              </h2>
                              <div className='row align-items-center w-150px justify-content-end'>
                                {values.quote.length > 1 && (
                                  <KTSVG
                                    onClick={() => remove(index)}
                                    path='/media/icons/duotune/general/gen027.svg'
                                    className='svg-icon-1 col-3 '
                                  />
                                )}
                                <KTSVG
                                  onClick={() => {
                                    let data = [...values.quote]

                                    data?.splice(index + 1, 0, {
                                      content: '',
                                      backgroundImage: '',
                                      backgroundImageName: '',
                                      toggleQuote: false,
                                    })
                                    setFieldValue('quote', data)
                                  }}
                                  path='/media/icons/duotune/general/gen028.svg'
                                  className='svg-icon-1 col-3'
                                />
                                <ToggleSwitch.Check
                                  onChange={() =>
                                    setFieldValue(`quote[${index}].toggleQuote`, !quote.toggleQuote)
                                  }
                                  name={`quote[${index}].toggleQuote`}
                                  checked={quote.toggleQuote}
                                  type='switch'
                                  id='custom-switch'
                                  className='col-4'
                                />
                              </div>
                            </div>
                            {quote.toggleQuote && (
                              <div className='mt-7'>
                                <Editor
                                  listData={listData}
                                  data={index}
                                  quote={quote}
                                  setQuote={(e: any) => setFieldValue(`quote[${index}].content`, e)}
                                  index={index}
                                  toolName={`quote${index}`}
                                  placeholder={'Write something or insert a heart ♥'}
                                />

                                <input
                                  ref={inputRef}
                                  onChange={(e: any) => {
                                    setFieldValue(
                                      `quote[${index}].backgroundImage`,
                                      e?.target?.files[0]
                                    )
                                    setFieldValue(
                                      `quote[${index}].backgroundImageName`,
                                      e?.target?.files[0]?.name
                                    )
                                  }}
                                  type={'file'}
                                  id={`backgroundImage${index}`}
                                  accept={'.jpeg,.png'}
                                  style={{display: 'none'}}
                                />
                                <label
                                  htmlFor={`backgroundImage${index}`}
                                  className='btn btn-light-primary mt-5 bg-img'
                                >
                                  Add backgroud image
                                </label>

                                {quote?.backgroundImageName !== '' && (
                                  <div className='d-flex mt-5'>
                                    {' '}
                                    <span className='d-block'>
                                      Media selected:{quote?.backgroundImageName}
                                    </span>
                                    <span className='ms-2'>
                                      <WSButton
                                        type='button'
                                        className={
                                          'btn btn-sm btn-icon btn-light btn-light-danger fw-500 fs-7 h-100 mh-20px w-20px d-flex justify-content-center align-items-center'
                                        }
                                        onClick={() => {
                                          inputRef.current.value = null
                                          setFieldValue(`quote[${index}].backgroundImage`, '')
                                          setFieldValue(`quote[${index}].backgroundImageName`, '')
                                        }}
                                        iconPath='/media/icons/duotune/arrows/arr061.svg'
                                        iconClass='svg-icon-8 mb-1'
                                      />
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          /////////////////////////
                        ))}
                      </div>
                    )}
                  </FieldArray>
                  <FieldArray name='bulletPoints'>
                    {({push, remove}) => (
                      <div>
                        {values.bulletPoints.map((bulletPoints: any, index: any) => (
                          <div className='border rounded border-2  p-7 ps-9 my-5' key={index}>
                            <div className='d-flex align-items-center justify-content-between position-relative'>
                              <h2 className=' text-bold col-4 m-0'>
                                <span className='six-dot'>
                                  <img
                                    src={toAbsoluteUrl('/media/icons/duotune/art/six-dot.svg')}
                                    className='me-5'
                                  />
                                </span>
                                BulletPoints
                              </h2>
                              <div className='row align-items-center w-150px justify-content-end'>
                                {values.bulletPoints.length > 1 && (
                                  <KTSVG
                                    onClick={() => remove(index)}
                                    path='/media/icons/duotune/general/gen027.svg'
                                    className='svg-icon-1 col-3 '
                                  />
                                )}
                                <KTSVG
                                  onClick={() => {
                                    let data = [...values.bulletPoints]

                                    data?.splice(index + 1, 0, {
                                      content: '',
                                      toggleBulletPoint: false,
                                    })
                                    setFieldValue('bulletPoints', data)
                                  }}
                                  path='/media/icons/duotune/general/gen028.svg'
                                  className='svg-icon-1 col-3'
                                />
                                <ToggleSwitch.Check
                                  onChange={() =>
                                    setFieldValue(
                                      `bulletPoints[${index}].toggleBulletPoint`,
                                      !bulletPoints.toggleBulletPoint
                                    )
                                  }
                                  name={`bulletPoints[${index}].toggleBulletPoint`}
                                  checked={bulletPoints.toggleBulletPoint}
                                  type='switch'
                                  id='custom-switch'
                                  className='col-4'
                                />
                              </div>
                            </div>
                            {bulletPoints.toggleBulletPoint && (
                              <div className='mt-7'>
                                <Editor
                                  listData={listData}
                                  data={index}
                                  quote={bulletPoints}
                                  setQuote={(e: any) =>
                                    setFieldValue(`bulletPoints[${index}].content`, e)
                                  }
                                  index={index}
                                  toolName={`bulletPoints${index}`}
                                  placeholder={'Write something or insert a heart ♥'}
                                />
                              </div>
                            )}
                          </div>
                          /////////////////////////
                        ))}
                      </div>
                    )}
                  </FieldArray>
                  <div className=' border rounded border-2  p-7 ps-9 my-5'>
                    <div className='d-flex align-items-center justify-content-between position-relative'>
                      <h2 className=' text-bold m-0'>
                        <span className='six-dot'>
                          <img
                            src={toAbsoluteUrl('/media/icons/duotune/art/six-dot.svg')}
                            className='me-5'
                          />
                        </span>
                        Where & when
                      </h2>
                      <ToggleSwitch.Check
                        onChange={() =>
                          setFieldValue(
                            'whereWhen.toggleWhereWhen',
                            !values.whereWhen.toggleWhereWhen
                          )
                        }
                        checked={values.whereWhen.toggleWhereWhen}
                        type='switch'
                        id='custom-switch'
                      />
                    </div>
                    {values.whereWhen.toggleWhereWhen && (
                      <div className='mt-7'>
                        <h4>Event Title</h4>
                        <Field
                          name='whereWhen.eventTitle'
                          value={values.whereWhen.eventTitle}
                          className='form-control form-control-lg form-control-solid mb-5'
                          placeholder='EOFY SALES'
                        />
                        <ErrorMessage
                          name='whereWhen.eventTitle'
                          component='div'
                          className='error'
                        />

                        <h4>Event Description</h4>
                        <Field
                          name='whereWhen.eventDescription'
                          value={values.whereWhen.eventDescription}
                          className='form-control form-control-lg form-control-solid mb-5'
                          placeholder='EOFY SALES'
                        />
                        <ErrorMessage
                          name='whereWhen.eventDescription'
                          component='div'
                          className='error'
                        />

                        <h4>Address</h4>
                        <Field
                          name='whereWhen.address'
                          value={values.whereWhen.address}
                          className='form-control form-control-lg form-control-solid mb-5'
                          placeholder='EOFY SALES'
                        />
                        <ErrorMessage name='whereWhen.address' component='div' className='error' />
                        <div className='col-md-12 mb-5 col-lg-12'>
                          <div className='row'>
                            <span className='col-6'>
                              <h4>Start</h4>
                              <DatePicker
                                selected={
                                  !!values.whereWhen.start ? new Date(values.whereWhen.start) : null
                                }
                                onChange={(date) => setFieldValue('whereWhen.start', date)}
                                showTimeSelect
                                dateFormat='MMMM d, yyyy h:mm aa'
                                className=' border-0 form-control form-control-lg form-control-solid'
                                placeholderText='Pick data & time'
                              />
                              <ErrorMessage
                                name='whereWhen.start'
                                component='div'
                                className='error'
                              />
                            </span>
                            <span className='col-6'>
                              <h4>End</h4>
                              <DatePicker
                                selected={
                                  !!values.whereWhen.end ? new Date(values.whereWhen.end) : null
                                }
                                onChange={(date) => setFieldValue('whereWhen.end', date)}
                                showTimeSelect
                                dateFormat='MMMM d, yyyy h:mm aa'
                                className=' border-0 form-control form-control-lg form-control-solid'
                                placeholderText='Pick data & time'
                                minDate={values.whereWhen.start}
                              />
                              <ErrorMessage
                                name='whereWhen.end'
                                component='div'
                                className='error'
                              />
                            </span>
                          </div>
                        </div>
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            checked={values.whereWhen.rsvpButtons}
                            onChange={() =>
                              setFieldValue('whereWhen.rsvpButtons', !values.whereWhen.rsvpButtons)
                            }
                            type={'checkbox'}
                            className='form-check-input'
                          />
                          <label className='ms-3'>Add RSVP buttons</label>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='border rounded border-2  p-7 ps-9 my-5'>
                    <div className='d-flex align-items-center justify-content-between position-relative'>
                      <h2 className=' text-bold col-4 m-0'>
                        <span className='six-dot'>
                          <img
                            src={toAbsoluteUrl('/media/icons/duotune/art/six-dot.svg')}
                            className='me-5'
                          />
                        </span>
                        RSVP / Custom Survey
                      </h2>

                      <ToggleSwitch.Check
                        onChange={() => setFieldValue('rsvp.toggleRsvp', !values.rsvp.toggleRsvp)}
                        checked={values.rsvp.toggleRsvp}
                        type='switch'
                        id='custom-switch'
                      />
                    </div>

                    {values.rsvp.toggleRsvp && (
                      <div className='mt-7 mw-650px'>
                        <h4>RSVP notification address / Custom Survey Address</h4>
                        <Field
                          name='rsvp.email'
                          value={values.rsvp.email}
                          className='form-control form-control-lg form-control-solid mb-5'
                          placeholder='EOFY SALES'
                        />
                        <ErrorMessage name='rsvp.email' component='div' className='error' />

                        <h4>RSVP Title / Custom Survey Title</h4>
                        <Field
                          name='rsvp.title'
                          value={values.rsvp.title}
                          className='form-control form-control-lg form-control-solid mb-5'
                          placeholder='EOFY SALES'
                        />
                        <ErrorMessage name='rsvp.title' component='div' className='error' />
                        <h4 className='mb-0'>RSVP OPTIONS / Custom Survey OPTIONS</h4>
                        <span className='label_helper'>
                          Choose which options your customer will have
                        </span>
                        <FieldArray name='option'>
                          {({push, remove}) => (
                            <div>
                              {values.rsvp.option.map((option: any, index: number) => (
                                <div key={index} className='col-8 mb-5 col-lg-11 input-delete'>
                                  <Field
                                    className='form-control form-control-lg form-control-solid'
                                    type='text'
                                    name={`rsvp.option[${index}]`}
                                  />

                                  {values.rsvp?.option.length > 1 && (
                                    <i
                                      onClick={() => {
                                        let newFormValues = [...values.rsvp?.option]
                                        newFormValues.splice(index, 1)
                                        setFieldValue('rsvp.option', newFormValues)
                                      }}
                                      className='bi bi-x'
                                    ></i>
                                  )}
                                </div>
                              ))}
                              <button
                                className='btn gray_bg_purple w-100'
                                onClick={(e) => {
                                  e.preventDefault()
                                  setFieldValue('option', values.rsvp.option.push(''))
                                }}
                              >
                                + Add New Option
                              </button>
                            </div>
                          )}
                        </FieldArray>
                      </div>
                    )}
                  </div>

                  <div className='mt-10'>
                    <label style={{fontWeight: 500, color: '#5F6276'}}>Landing page name</label>
                    <div className='d-flex align-items-center mw-md-75 mt-2 flex-column flex-sm-row'>
                      <Field
                        value={values.campaignName}
                        name='campaignName'
                        type='text'
                        placeholder='Cool template'
                        data-testid='inputTemplateName'
                        className='me-3 form-control form-control-lg form-control-solid'
                      />
                      <ErrorMessage name='campaignName' component='div' className='text-danger' />
                      <button className='btn btn-primary mt-3 mt-sm-0' style={{minWidth: '190px'}}>
                        Save Landing page
                      </button>
                    </div>
                  </div>
                </div>
                <div className='landing_right d-flex flex-start col-xl-4 col-sm-12 step2-main mt-10 mt-xl-0'>
                  <div
                    className='mobile-bg-wrapper grey-bg'
                    style={{
                      backgroundImage: `url(${toAbsoluteUrl('/media/mobile/iphone_white_bg.png')})`,
                    }}
                  >
                    <div className='inner-content-main'>
                      <>
                        {values.header.toggleHeader && (
                          <>
                            <div className='text-center'>
                              <>
                                {values.header?.logo !== null && values.header?.logo !== '' && (
                                  <>
                                    {' '}
                                    {typeof values.header?.logo !== 'object' ? (
                                      <img
                                        className='h-30px d-block ms-auto me-auto'
                                        style={{marginTop: '20px'}}
                                        src={values.header?.logo}
                                        alt='poster'
                                      />
                                    ) : (
                                      <img
                                        className='h-30px d-block ms-auto me-auto'
                                        style={{marginTop: '20px'}}
                                        src={URL.createObjectURL(values.header?.logo)}
                                        alt='poster'
                                      />
                                    )}
                                  </>
                                )}
                                {values.header?.logo == '' && (
                                  <img src={toAbsoluteUrl('/media/misc/image-logo.png')} />
                                )}
                              </>
                              <h1 className='d-flex justify-content-center landingPageHeading'>
                                {values.header?.campaignMessage ||
                                  'Steve, you are invited to our EOFY party'}
                              </h1>

                              {values.header?.media !== '' && values.header?.media !== null && (
                                <>
                                  {typeof values.header?.media !== 'object' ? (
                                    <img
                                      className='col-12'
                                      style={{marginTop: '20px'}}
                                      src={values.header?.media}
                                      alt='poster'
                                    />
                                  ) : (
                                    <img
                                      className='col-12'
                                      style={{marginTop: '20px'}}
                                      src={URL.createObjectURL(values.header?.media)}
                                      alt='poster'
                                    />
                                  )}
                                </>
                              )}

                              {values.header?.youtubeLink !== '' && (
                                <>
                                  <div className='youtubeWrapper d-flex'>
                                    <YouTube
                                      id='youtubeDiv'
                                      videoId={values.header?.youtubeLink?.split('=')?.at(-1)}
                                      opts={opts}
                                      onReady={onPlayerReady}
                                    />
                                  </div>
                                </>
                              )}

                              {values?.header?.toggleHeroMedia &&
                                values.header?.youtubeLink == '' &&
                                values.header?.media == '' && (
                                  <img src={toAbsoluteUrl('/media/misc/Rectangle 3572.png')} />
                                )}
                            </div>
                          </>
                        )}
                        {values.quote
                          ?.filter((data: any) => data?.toggleQuote)
                          ?.map((key: any, i: number) => {
                            return (
                              <React.Fragment key={i}>
                                {typeof key?.backgroundImage == 'string' ? (
                                  <div
                                    className='LandingPageContent d-flex justify-content-center align-items-center flex-column my-5'
                                    style={{
                                      backgroundImage: `url(${key?.backgroundImage})`,
                                    }}
                                  >
                                    <div dangerouslySetInnerHTML={{__html: key?.content}} />
                                  </div>
                                ) : (
                                  <>
                                    {
                                      <div
                                        className='position-relative z-10000 LandingPageContent d-flex justify-content-center align-items-center flex-column my-5'
                                        style={{
                                          backgroundImage: `url(${URL.createObjectURL(
                                            key?.backgroundImage
                                          )})`,
                                        }}
                                      >
                                        <div
                                          className='text-light'
                                          dangerouslySetInnerHTML={{__html: key?.content}}
                                        />
                                      </div>
                                    }
                                  </>
                                )}
                              </React.Fragment>
                            )
                          })}

                        <div className='mt-2'>
                          {values.bulletPoints
                            ?.filter((data: any) => data?.toggleBulletPoint)
                            ?.map((key: any, i: number) => {
                              return (
                                <div key={i} dangerouslySetInnerHTML={{__html: key?.content}} />
                              )
                            })}
                        </div>
                        {values.whereWhen?.toggleWhereWhen ? (
                          <>
                            <div className='text-center'>
                              <p className='fw-bolder'>{values.whereWhen.eventTitle}</p>
                            </div>
                            <div className='text-center mb-7'>
                              <p>{values.whereWhen.eventDescription}</p>
                            </div>
                          </>
                        ) : null}
                        {values.whereWhen?.end !== null &&
                          values.whereWhen?.start !== null &&
                          values.whereWhen?.toggleWhereWhen && (
                            <div className='text-center mb-7'>
                              <h5 className='fw-bolder mb-1'>When -</h5>
                              <div className='mb-8'>
                                <p className='mb-0'>
                                  {moment(values.whereWhen?.start)?.format('dddd, MMMM Do [at] h:mm A')} and
                                </p>
                                <p className='mt-0'>
                                  {moment(values.whereWhen?.end)?.format('dddd, MMMM Do [at] h:mm A')}
                                </p>
                              </div>
                              {values.whereWhen?.end !== null && values.whereWhen?.start !== null && (
                                <div className='text-center mb-7'>
                                  <h5 className='fw-bolder mb-1'>Where -</h5>
                                  <p className='mb-2'>
                                    {values.whereWhen?.address == ''
                                      ? '500 Brighton Road Melbouene VIC 3805 (03) 9591 0786'
                                      : values.whereWhen?.address}
                                  </p>
                                </div>
                              )}
                            </div>
                          )}

                        {values.rsvp?.toggleRsvp && (
                          <div className='d-flex flex-column w-70 mb-3'>
                            <h3>{values.rsvp?.title}</h3>
                            {values.rsvp?.option?.map((key: any, i: number) => {
                              return (
                                <React.Fragment key={i}>
                                  {key !== '' && (
                                    <div className='landingpage_inside_label d-flex gap-2'>
                                      <input type='radio' disabled/>
                                      <label>{key}</label>
                                    </div>
                                  )}
                                </React.Fragment>
                              )
                            })}
                          </div>
                        )}

                        {values.whereWhen?.start &&
                          values.whereWhen?.end &&
                          values.whereWhen?.start !== null &&
                          values.whereWhen?.end !== null &&
                          values.whereWhen?.toggleWhereWhen && (
                            <div className='text-center'>
                              {/* <div onClick={downloadIcal} className='btn btn-primary mb-2'>
                                Outlook Calender
                              </div>
                              <div onClick={googleCalander} className='btn btn-primary mb-2'>
                                Google Calender
                              </div>
                              <div onClick={downloadIcal} className='btn btn-primary mb-2'>
                                ical
                              </div> */}
                            </div>
                          )}
                      </>
                    </div>
                    {/* <div className='wrapper-tabs'>
                <Tabs
                  defaultActiveKey='notification'
                  className='nav nav-tabs nav-pills border rounded p-2 fs-6 text-dark d-flex justify-content-between'
                >
                  <Tab eventKey='notification' title='Notification' />
                  <Tab eventKey='message' title='Message' />
                </Tabs>
              </div> */}
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  )
}

export default CreateLandingPage
